import dayjs, { Dayjs } from 'dayjs';
import isoWeek from 'dayjs/plugin/isoWeek';
import quarterOfYear from 'dayjs/plugin/quarterOfYear';

import { BenchmarkTimeGrouping } from 'views/benchmark-analytics/types/benchmark-filters.type';

dayjs.extend(isoWeek);
dayjs.extend(quarterOfYear);

const DATE_FORMAT = 'YYYY-MM-DD';

// Snap to whole periods, so the first and last period are never partial. Returns the 'YYYY-MM-DD' the filters store.
export const snapToPeriod = (date: Dayjs | string, grouping: BenchmarkTimeGrouping, field: 'from' | 'to'): string => {
  const day = dayjs(date);
  if (grouping === 'week') return (field === 'from' ? day.startOf('isoWeek') : day.endOf('isoWeek')).format(DATE_FORMAT);

  return (field === 'from' ? day.startOf(grouping) : day.endOf(grouping)).format(DATE_FORMAT);
};
